import { render } from "./EditAccount.vue?vue&type=template&id=5e08a58a&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"

import "./EditAccount.vue?vue&type=style&index=0&id=5e08a58a&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e08a58a"]])

export default __exports__